import router from './Router';

export default router;
